import type { ProjectDocType } from '@ast-data/shared';
import { useRxCollection, useRxDocument } from 'rxdb/plugins/react';

/**
 * The open project, or null on the picker page. Gated on the URL and not just on
 * the query result: the hook keeps emitting the last-loaded project after we
 * leave it, so without the gate the old name lingers on the picker page.
 */
export function useActiveFieldProject(
    projectId: string | null
): ProjectDocType | null {
    const projectsCollection = useRxCollection<ProjectDocType>('projects');
    const { result: projectDoc } = useRxDocument<ProjectDocType>(
        projectsCollection,
        projectId ?? undefined
    );
    return projectDoc ? (projectDoc.toMutableJSON() as ProjectDocType) : null;
}
